import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CustomCreate from '@/components/global/list/CustomCreate.jsx';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import { ProductForm } from '@/components/product/forms/ProductForm.jsx';
import { productCreateStyles } from '@/themes/commonStyles/productForm.js';

export const StyledProductCreate = styled(Box)(productCreateStyles);

export const ProductCreate = ({ handleClose }) => {
    const translate = useTranslate();
    return (
        <StyledProductCreate>
            <Box className='popup-wrapper popup-wrapper-top'>
                <Box className='popup-box popup-box--header'>
                    <Typography variant='h4'>{translate('resources.product.labels.addProduct')}</Typography>
                    <Box>
                        <CustomCloseButton onClose={handleClose} />
                    </Box>
                </Box>
            </Box>
            <CustomCreate handleClose={handleClose} mutationMode='pessimistic'>
                <Box className='padding-wrapper'>
                    <ProductForm handleClose={handleClose} />
                </Box>
            </CustomCreate>
        </StyledProductCreate>
    );
};

ProductCreate.propTypes = {
    handleClose: PropTypes.func,
};
